<!-- No backdrop-blur on the scrim: it forces the compositor to re-blur the whole viewport on every
     animated frame while the slideout is open (TD #32988). Scrim opacity alone matches Material. -->
<div
  class="[ fixed inset-0 scrim bg-opacity-low transition-opacity duration-medium-1 ease-emphasized ]"
  (click)="clickScrim($event)"
  [style.zIndex]="index * 2 + 98"
  [@fadeIn]="active"
></div>
<div
  class="[ tablet-l:min-w-2xl surface flex flex-column corner-m elevation-4 max-w-screen fixed inset-ie-s inset-b-s ]"
  [style.zIndex]="index * 2 + 99"
  [@slideIn]="animState"
  (@slideIn.done)="onSlideInDone()"
  >
  <div class="[ flex flex-nowrap items-center p-be-s p-bs-xs p-is-m p-ie-xs ]">
    @if (title) {
      <h5 class="flex-1" data-cy="slideout-modal-header">
        {{ title }}
      </h5>
    }
    @if (!title) {
      <div class="[ w-full ]">
        <ng-content select="campus-slideout-modal-header-content"></ng-content>
      </div>
    }
    <ng-content select="campus-slideout-modal-header-actions"></ng-content>
  </div>
  <dcr-divider></dcr-divider>
  <div class="[ p-bs-s p-i-m overflow-y-auto flex-1 ]">
    <ng-content></ng-content>
  </div>
  @if (hasBottomActions) {
    <div>
      <dcr-divider></dcr-divider>
      <div class="[ p-bs-s p-be-m p-i-m ]">
        <ng-content select="campus-slideout-modal-bottom-actions"> </ng-content>
      </div>
    </div>
  }
</div>
